import PropTypes from "prop-types";
import {
    LuChevronFirst,
    LuChevronLast,
  LuChevronLeft,
  LuChevronRight,
} from "react-icons/lu";
import { MdArrowDropDown } from "react-icons/md";
import styles from "./styles.module.css";

const Pagination = ({
  page,
  pageSize,
  totalCount,
  pageSizeOptions,
  onFirstPage,
  onPrevPage,
  onNextPage,
  onLastPage,
  onPageSizeChange,
}) => {
  const from = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  const isFirstDisabled = page <= 1;
  const isNextDisabled = page >= totalPages;

  return (
    <div className={styles.paginationWrapper}>
      <div className={styles.leftSection}>
        <span className={styles.rowsLabel}>Rows per page:</span>
        <div className={styles.pageSizeSelectWrap}>
    <select
      className={styles.pageSizeSelect}
      value={pageSize}
      onChange={(e) => onPageSizeChange(Number(e.target.value))}
    >
      {pageSizeOptions.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>

    <span className={styles.pageSizeArrow}>
      <MdArrowDropDown size={22} />
    </span>
  </div>
      </div>

      <div className={styles.middleSection}>
        {from} - {to} of <strong>{totalCount}</strong>
      </div>

      <div className={styles.rightSection}>
        <button
          type="button"
          className={styles.iconBtn}
          onClick={onFirstPage}
          disabled={isFirstDisabled}
          aria-label="First page"
        >
          <LuChevronFirst size={24} />
        </button>

        <button
          type="button"
          className={styles.iconBtn}
          onClick={onPrevPage}
          disabled={isFirstDisabled}
          aria-label="Previous page"
        >
          <LuChevronLeft size={24} />
        </button>

        <button
          type="button"
          className={styles.iconBtn}
          onClick={onNextPage}
          disabled={isNextDisabled}
          aria-label="Next page"
        >
          <LuChevronRight size={24} />
        </button>

        <button
          type="button"
          className={styles.iconBtn}
          onClick={onLastPage}
          disabled={isNextDisabled}
          aria-label="Last page"
        >
          <LuChevronLast size={24} />
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  onFirstPage: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
  onLastPage: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
};

export default Pagination;